module.exports = __webpack_public_path__ + "img/img_kyc_shadow.8baedb3.png";